import "core-js/modules/es.array.push.js";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", [_c("a-table", {
    staticClass: "marginT20",
    attrs: {
      bordered: "",
      columns: _vm.columns,
      "data-source": _vm.data,
      align: "center",
      pagination: _vm.pagination,
      rowKey: "id"
    },
    on: {
      change: _vm.handleStandardTableChange
    },
    scopedSlots: _vm._u([{
      key: "index",
      fn: function (text, record, index) {
        return [_vm._v(" " + _vm._s(index + 1) + " ")];
      }
    }, {
      key: "action",
      fn: function (text, record) {
        return [_c("a-button", {
          attrs: {
            size: "small"
          },
          on: {
            click: function ($event) {
              return _vm.$router.push({
                name: "customerUsedClaim",
                params: {
                  id: record.claimsReviewId,
                  type: 1,
                  nodeid: record.nodeId
                }
              });
            }
          }
        }, [_vm._v(_vm._s(_vm.$t("查看")))]), _c("a-button", {
          staticClass: "marginL15",
          attrs: {
            type: "edit",
            size: "small"
          },
          on: {
            click: function ($event) {
              return _vm.$router.push({
                name: "customerUsedClaim",
                params: {
                  id: record.claimsReviewId,
                  type: 2,
                  nodeid: record.nodeId
                }
              });
            }
          }
        }, [_vm._v(_vm._s(_vm.$t("审核")))])];
      }
    }])
  }, _vm._l(_vm.columns, function (item, i) {
    var _item$slots, _item$slots2, _item$slots3;
    return _c("span", {
      key: i,
      attrs: {
        slot: (_item$slots = item.slots) === null || _item$slots === void 0 ? void 0 : _item$slots.title
      },
      slot: (_item$slots2 = item.slots) === null || _item$slots2 === void 0 ? void 0 : _item$slots2.title
    }, [_vm._v(_vm._s(_vm.$t((_item$slots3 = item.slots) === null || _item$slots3 === void 0 ? void 0 : _item$slots3.title)))]);
  }), 0)], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };